import React, {useEffect, useState} from "react";
import {Session, User} from "../types/Types";
import {Card} from "react-bootstrap";
import UserRow from "./UserRow";
import LeaderboardNav from "./LeaderboardNav";
import {addNumberSuffix} from "../util/Util";
import PageTracking from "../auth/PageTracking";
import {V2GlassPanel} from "../shared/v2/V2Glass";
import LeaderboardV2Rows from "./LeaderboardV2Rows";

interface Props {
    users: Array<User>;
    currentUser: User | undefined;
    sessionsMap: Map<string, Session>;
}

function LeaderboardPhotos(props: Props) {

    const [rank, setRank] = useState<number>(0);
    const [rankedUsers, setRankedUsers] = useState<Array<User> | undefined>();

    useEffect(() => {
        (async () => {
            const usersArray: Array<User> = props.users
                .filter((user) => {return user.photoCount > 0})
                .sort((a: User, b: User) => {return b.photoCount - a.photoCount})
            setRankedUsers(usersArray);
        })();
    }, [props.users]);

    useEffect(() => {
        (async () => {
            if(!rankedUsers) {
                return;
            }
            setRank(0)
            rankedUsers.forEach((user, index) => {
                if(props.currentUser && user.id === props.currentUser.id) {
                    setRank(index + 1);
                    return;
                }
            });
        })();
    }, [rankedUsers, props.currentUser]);

    return (
        <>
            <PageTracking />
            {props.currentUser && <>
            <LeaderboardNav currentUser={props.currentUser} />
            {rankedUsers && (props.currentUser.enableUiV2 ? <V2GlassPanel className="leaderboard-v2-list-card v2-glass-list-panel">
                <div className="leaderboard-v2-summary">
                    {rank > 0 && <span>You&apos;re ranked <b>{rank}{addNumberSuffix(rank)}</b> out of <b>{rankedUsers.filter((user) => !user.socialDisabled).length}</b></span>}
                    {rank === 0 && <span>You haven&apos;t taken any photos yet.</span>}
                </div>
                <LeaderboardV2Rows
                    rows={rankedUsers
                        .filter((user) => !user.socialDisabled)
                        .filter((user) => user.photoCount > 0)
                        .map((user) => ({
                            user,
                            value: user.photoCount,
                            session: props.sessionsMap.get(user.id),
                        }))}
                    linksToTab="photos"
                    emptyMessage="No photos recorded yet."
                />
            </V2GlassPanel> : <Card className={"mb-3"}>
                <Card.Header>
                    {(rank === 0) && <div>You haven't taken any photos yet.</div>}
                    {(rank > 0) && <div>You're ranked: {rank}<small>{addNumberSuffix(rank)}</small> out of {rankedUsers.length}</div>}
                </Card.Header>
                <Card.Body style={{paddingTop: "0.4em"}}>
                    {rankedUsers
                        .filter((user) => {return !user.socialDisabled})
                        .filter((user) => user.photoCount > 0)
                        .map((user: User, index: number) => (
                            <UserRow linksToTab="photos" countToDisplay={user.photoCount.toString()} key={user.id} index={index} user={user} session={props.sessionsMap.get(user.id)} minWidth="205px"/>
                        ))}
                    {(rankedUsers.length === 0 || rank === 0) && <div className={'loading'}>
                        Loading...
                    </div>}
                </Card.Body>
            </Card>)}
        </>}
        </>
    );
}

export default LeaderboardPhotos;
